export default __webpack_public_path__ + "static/media/node-2.09d56d51.jpg";